/* TODO: t() */
import React, { Component } from 'react';
import { Image, TouchableOpacity, View, StyleSheet } from 'react-native';

import { themeColors } from './Constants';
import Icon from './Icon';
import Text from './Text';
import { Attachment } from '../../types/shared/FileUpload';

type Props = {
  url: string;
  file: Attachment;
  onPress: (file: Attachment) => void;
  onDownload: (file: Attachment) => void;
};

class DownloadPreview extends Component<Props> {
  static defaultProps = {
    acceptMultipleFiles: false,
    imageOnly: false,
  };

  render() {
    let { file, onPress, onDownload } = this.props;
    return (
      <View>
        <TouchableOpacity
          style={styles.previewWrapper}
          onPress={() => onPress(file)}
        >
          {this._renderPreview(file)}
          <Text style={styles.fileName} type="label" numberOfLines={1}>
            {file.fileName}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.buttonIcon}
          onPress={() => onDownload(file)}
        >
          <Icon name="download" size="M" />
        </TouchableOpacity>
      </View>
    );
  }

  _renderPreview = (file: Attachment) => {
    if (file.fileType.includes('image')) {
      return <Image style={styles.preview} source={{ uri: this.props.url }} />;
    } else if (file.fileType.includes('pdf')) {
      return (
        <View style={styles.preview}>
          <Icon name="pdf" size="M" style={styles.iconStyle} />
        </View>
      );
    } else {
      return (
        <View style={styles.preview}>
          <Icon name="description" size="M" style={styles.iconStyle} />
        </View>
      );
    }
  };
}

let styles = StyleSheet.create({
  previewWrapper: {
    padding: 5,
    alignItems: 'center',
  },
  preview: {
    width: 150,
    height: 150,
    borderWidth: 1,
    borderColor: themeColors.borderGrey,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  fileName: {
    position: 'absolute',
    flex: 1,
    bottom: 5,
    width: 150,
    padding: 2,
    borderWidth: 0,
    backgroundColor: themeColors.grey,
    textAlign: 'center',
  },
  iconStyle: {
    margin: 8,
  },
  buttonIcon: {
    position: 'absolute',
    backgroundColor: themeColors.white,
    zIndex: 2,
    top: 10,
    right: 10,
    opacity: 0.7,
    borderRadius: 2,
    marginHorizontal: 2,
  },
});

export default DownloadPreview;
